import { forwardRef, type Ref, type SVGProps } from "react";
const IconBlueprintOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 4H8V3a1 1 0 0 0-1-1H6a4 4 0 0 0-4 3.8A1.3 1.3 0 0 0 2 6v20a4 4 0 0 0 4 4h22a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M4 6a2 2 0 0 1 2-2v18a3.9 3.9 0 0 0-2 .56Zm24 22H6a2 2 0 0 1 0-4h1a1 1 0 0 0 1-1V6h20Z" />
    <path d="M26 10.29v13.42A2.3 2.3 0 0 1 23.71 26H17a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-1v2h5.71a.29.29 0 0 0 .29-.29V16h-2a1 1 0 0 1 0-2h2v-3.71a.29.29 0 0 0-.29-.29H12.29a.29.29 0 0 0-.29.29V14h4v-1a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0v-1h-4v7.71a.29.29 0 0 0 .29.29H13a1 1 0 0 1 0 2h-.71A2.3 2.3 0 0 1 10 23.71V10.29A2.3 2.3 0 0 1 12.29 8h11.42A2.3 2.3 0 0 1 26 10.29" />
  </svg>
);
const ForwardRef = forwardRef(IconBlueprintOutlineSVG);
ForwardRef.displayName = "IconBlueprintOutline";
export { ForwardRef as IconBlueprintOutline };
